import { useContext, useEffect, useRef, useState } from "react";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { API } from "../../Axios/Axios";
import { LoaderContext } from "../../Helpers/Context/Context";
import {
  UnorderedListOutlined,
  PlusOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import { FormInput } from "../../Components/FormInputs/FormInputs";
import type { CollapseProps } from "antd";
import {
  Tabs,
  Card,
  Row,
  Col,
  Button,
  Select,
  Dropdown,
  Menu,
  Form,
  InputNumber,
  Collapse,
  Checkbox,
  Radio,
  message,
  Input,
  Flex,
  Modal,
  PopConfirm,
  Tooltip,
  DatePicker,
} from "antd";
import { Category } from "@mui/icons-material";
import FormTable from "../../Components/DynamicTable/FormTable";
import { useLocation } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { ExpandIconPosition } from "antd/es/collapse/Collapse";
import PdfViewer from "../../FileReader/PdfViewer";
import ImageViewer from "../../FileReader/ImageViewer";
import {
  downloadReport,
  getDropdownsForReport,
  getFileData,
  getInvestmentCycleForVerification,
  getReportRequestDashboardData,
} from "../../Helpers/APIEndpoints/Endpoints";

import { BsThreeDotsVertical } from "react-icons/bs";
import ChatBox from "../../Components/Chatbox/ChatBox";
import { useNavigate } from "react-router-dom";
import { FormSelect } from "../../Components/FormSelect";
import * as AntIcons from "@ant-design/icons";
import { useActionHandler } from "../../Components/ActionHandlerContext";
import dayjs, { Dayjs } from 'dayjs';
import { useWatch } from "antd/es/form/Form";


interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "text";
  record: Item;
  index: number;
  children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType ? (
    inputType === "number" ? (
      <InputNumber />
    ) : (
      <Input />
    )
  ) : (
    <Input />
  );

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

interface IOptions {
  label?: string;
  value?: number | string;
  code?: string;
}

interface IFormData {
  categoryType?: IOptions | any;
  investmentCycle?: IOptions | any;
  reportType?: IOptions | any;
  company?: IOptions | any;
}

const ReportRequestDashboard = ({ }: any) => {
  const [form] = Form.useForm();
  const reportsType = useWatch("reporttype",form);
  const [data, setData] = useState([]);
  const [dataConfig, setDataConfig] = useState(null);
  const [editingKey, setEditingKey] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [activeTab, setActiveTab] = useState("Actions");
  //const [columns, setColumns] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filtersvalue, setFiltersValue] = useState("");
  const [isTableLoading, setTableLoading] = useState<boolean>(false);
  const [isReset, setIsReset] = useState(false);
  const [selectRecordIds, setSelectRecordIds] = useState([]);
  const location = useLocation();
  const { state } = location || {};
  const navigate = useNavigate(); // Ho
  const [totalcount, setTotalCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  //const [actionButtons, setActionButtons] = useState([]);
  const [pageButtons, setPageButtons] = useState([]);
  const [enableSearch, setenableSearch] = useState<Boolean>();
  const [checkBoxFlag, setcheckBoxFlag] = useState<Boolean>();
  const { rowActionHandler, reportActionHandler } = useActionHandler();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { userId, currentRoleId, permissionRecord, currentFinancialYearId } =
    useAuthStore();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingState, setLoadingState] = useState({});
  const isEditing = (record: Item) => record.key === editingKey;

  const [formOptions, setFormOptions] = useState<IFormData>({});
  const [formData, setFormData] = useState<IFormData>({});
  const [currCategoryTypeId, setCurrCategoryTypeId] = useState(0);

  const columns = [
    {
      title: "Sr.No",
      key: "Sr.No",
      dataIndex: "srNo",
      //fixed: "right",
      width: 100,
    },
    {
      title: "Report Type",
      key: "ReportType",
      dataIndex: "reportType",
      //fixed: "right",
      width: 100,
    },
    {
      title: "Company",
      key: "Company",
      dataIndex: "company",
      //fixed: "right",
      width: 100,
    },
    {
      title: "Investment Cycle",
      key: "Investment Cycle",
      dataIndex: "investmentCycle",
      //fixed: "right",
      width: 100,
    },
    {
      title: "Start Date",
      key: "Start Date",
      dataIndex: "formattedStartDate",
      //fixed: "right",
      width: 100,
    },
    {
      title: "End Date",
      key: "End Date",
      dataIndex: "formattedEndDate",
      //fixed: "right",
      width: 100,
    },
    {
      title: "Generated date and Time",
      key: "Generated date and Time",
      dataIndex: "fileGeneratedDate",
      //fixed: "right",
      width: 100,
    },
    {
      title: "Generated By",
      key: "Generated By",
      dataIndex: "fileGeneratedBy",
      //fixed: "right",
      width: 100,
    },
    {
      title: "Status",
      key: "Status",
      dataIndex: "status",
      //fixed: "right",
      width: 100,
    },
  ];

  const actionButtons = [
    {
      type: "DynamicMasterRowDownload",
      label: "Download",
      icon: "DownloadOutlined",
    },
  ];

  const actionColumn = {
    title: "Actions",
    key: "actions",
    fixed: "right",
    width: 100,
    render: (_, record) => {
      {
        const actionElements = [];

        if (record.fileName) {
          const downloadButton = actionButtons?.find(
            (btn: any) => btn.label === "Download"
          );
          if (downloadButton) {
            actionElements.push(
              <Tooltip title={downloadButton.label} key="download">
                <Button
                  icon={getIcon(downloadButton.icon)}
                  //onClick={() => handleActionButtonClick(downloadButton, record.key, record)}
                  onClick={() =>
                    handleFileDownload(downloadButton, record.key, record)
                  }
                  type="link"
                  title={downloadButton.type}
                  loading={loadingState[record.key]?.[downloadButton.type]}
                />
              </Tooltip>
            );
          }
        }

        return (
          <div style={{ display: "flex", gap: "8px" }}>{actionElements}</div>
        );
      }
    },
  };

  //table functions
  const mergedColumns = [
    ...columns?.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record: Item) => ({
          record,
          inputType: col.dataIndex === "age" ? "number" : "text",
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
        }),
      };
    }),
    actionColumn,
    //stateDashboardId == 6 ? [] : actionColumn, // action column hide for employee master screen only
  ];

  const getIcon = (iconName) => {
    const Icon = AntIcons[iconName];
    if (Icon) {
      return <Icon />;
    }
    // If icon name is not found, return null or a default icon (optional)
    return null;
  };

  const handleActionButtonClick = async (
    button: any,
    recordId: any,
    record: any
  ) => {
    const { type, ...params } = button;

    console.log("record===>", record);
    console.log("buttons===>", button);

    setLoadingState((prevState) => ({
      ...prevState,
      [recordId]: { ...prevState[recordId], [type]: true },
    }));

    try {
      if (rowActionHandler[type]) {
        // Call the appropriate handler and wait for the result (if it's async)
        const result = await rowActionHandler[type](type, record);
        // Handle success
        if (result) {
          // message.success(
          //   `Handler for ${type} executed successfully: ${result}`
          // );
          console.error(
            `Handler for "${type}" executed successfully: ${result}`
          );
        }
      } else {
        message.error(`No handler found for ${type}`);
      }
    } catch (error) {
      // Handle error
      message.error(`Error executing handler for ${type}: ${error.message}`);
    } finally {
      // Set the loading state for the specific record and button to false
      setLoadingState((prevState) => ({
        ...prevState,
        [recordId]: { ...prevState[recordId], [type]: false },
      }));
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };
  // const handlePageActionClick = async (button: any) => {
  //     setLoadingState((prev) => ({ ...prev, [button.label]: true }));
  //     try {
  //         // if action object is empty for buttons
  //         if (!button?.actions || button?.actions?.length === 0) {
  //             console.error(`No action found for this ${button.label} button`);
  //             return;
  //         }
  //         let formValue = { ...form.getFieldsValue() };

  //         //for export to excel call downloadExcel only
  //         if (button?.actionType === "DynamicReportActionExportToExcel") {
  //             downloadExcel(formValue, stateDashboardId);
  //         } else {
  //             // for all other buttons
  //             for (const action of button.actions) {
  //                 const { execType, execData } = action;
  //                 let result;
  //                 if (execType === "Function") {
  //                     if (!reportActionHandler[execData]) {
  //                         console.error(`No handler found for function: ${button.label}`);
  //                         return;
  //                     }
  //                     result = await reportActionHandler[execData](
  //                         button.actionType,
  //                         button
  //                     );
  //                 } else if (execType === "Query" || execType === "SP") {
  //                     // if (!reportActionHandler[execType]) {
  //                     //   console.error(`No handler found for Query/SP: ${button.label}`);
  //                     //   return;
  //                     // }
  //                     // result = await reportActionHandler[execData](button);
  //                     result = await API.post(executeReportAction, {
  //                         ReportId: stateDashboardId,
  //                         ActionType: button.actionType,
  //                         ActionId: action.actionId,
  //                         FormData: JSON.stringify(formValue)
  //                     });
  //                     if (result?.data?.status == 1) {
  //                         message.error(`Failed.`);
  //                         console.log(
  //                             button.actionId + " failed : " + result?.data?.message
  //                         );
  //                     } else if (result?.data?.status > 0) {
  //                         message.warning(result?.data?.message);
  //                     }
  //                 } else {
  //                     console.error(`Unsupported execType: ${execData}`);
  //                     return;
  //                 }
  //                 if (!result) {
  //                     // message.error(
  //                     //   `Handler for "${button.label}" executed but returned no result.`
  //                     // );
  //                     console.error(`Handler for "${button.label}" executed but returned no result.`);
  //                     return;
  //                 } else {
  //                     // message.success(
  //                     //   `Handler for "${button.label}" executed successfully: ${result}`
  //                     // );
  //                     console.error(`Handler for "${button.label}" executed successfully: ${result}`);
  //                 }
  //             }
  //         }
  //     } catch (error) {
  //         console.error(`No action found for this ${button.label}:`, error);
  //         message.error(`No action found for this ${button.label}`);
  //     } finally {
  //         setLoadingState((prev) => ({ ...prev, [button.label]: false }));
  //     }
  // };

  const handleButtonClick = async (form: any, buttonConfig: any) => {
    try {
      if (buttonConfig === "reset") {
        form.resetFields();
        setIsReset(!isReset);
        //clearing rowForm Data:
        getReportData();
        // message.info("Form reset successfully.");
        //console.log("Form reset successfully.");

        return;
      }

      if (buttonConfig.actionKey.toLowerCase() === "apply") {
        //await form.validateFields();
        let formValue = { ...form.getFieldsValue() };
        if (formValue) {
          Object.keys(formValue).forEach((key) => {
            if (Array.isArray(formValue[key])) {
              formValue[key] = formValue[key].join(",");
            }
          });
        }
        setFiltersValue(formValue);
        getReportData(formValue);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  //get dashboard data
  const getReportData = async (
    formValue = null,
    Querry = "",
    PageSize = 10,
    PageNumber = 1
  ) => {
    try {
      let fetchResponse = await API.post(getReportRequestDashboardData, {
        // currently Hardcoaded
        UserId: userId,
        RoleId: currentRoleId,
        PageNumber: PageNumber,
        PageSize: PageSize,
        sortBy: "ModifiedDateUtc",
        desc: true,
        SearchText: searchText,

        // FormData: formValue != null ? JSON.stringify(formValue) : null,
        // ReportQuery: Querry != "" ? Querry : dataConfig?.reportQuery,
      });

      if (fetchResponse?.data?.data?.length > 0) {
        //console.log("fetchResponse::::::::::", fetchResponse);

        // Add a new key-value pair to each object inside fetchResponse.data
        const updatedData = fetchResponse.data.data.map((item) => ({
          ...item, // Spread existing object properties
          key: item?.Id || item?.key,
          interfaceId: state?.id || 0, // Add your new key-value pair
        }));
        //console.log("updatedData Count::::::::::", updatedData[0].TotalCount);
        setTotalCount(updatedData[0].totalCount);

        setData(updatedData);
      } else {
        console.log("fetchResponse is empty or undefined");

        // Handle empty response scenario
        setTotalCount(0); // Reset total count
        setData([]); // Ensure data is cleared or set to an empty array
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  //screen functions
  useEffect(() => {
    getDropdownValues();
    getReportData();
  }, []);

  //filters
  const getDropdownValues = async () => {
    try {
      showLoader();

      let response = await API.post(getDropdownsForReport, {
        Mode: "",
        FinancialYearId: currentFinancialYearId,
      });

      if (response.data && response.data.data) {
        setFormOptions((prev) => {
          return {
            ...prev,
            categoryType: response.data.data.categoryTypeList || [],
            investmentCycle: response.data.data.investmentCycleList || [],
            company: response.data.data.companyList || [],
          };
        });
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  const getReportTypeDropdown = async (typeId: any) => {
    try {
      showLoader();

      setCurrCategoryTypeId(typeId);

      let response = await API.post(getDropdownsForReport, {
        Mode: "reporttype",
        FinancialYearId: currentFinancialYearId,
        CategoryTypeId: typeId,
      });

      if (response.data && response.data.data) {
        setFormOptions((prev) => {
          return {
            ...prev,
            reportType: response.data.data.reportTypeList || [],
          };
        });
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  const handleDownloadReport = async () => {
    try {
      debugger;
      showLoader();
      const validate = await form.validateFields();

      await insertReportRequest();
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
    } finally {
      hideLoader();
    }
  };

  const insertReportRequest = async () => {
    try {
      debugger;
      showLoader();

      const fields = form.getFieldValue();

      const requestParams = {
        Id: 0,
        FinancialYearId: currentFinancialYearId,
        CategoryTypeId: fields.type,
        ReportTypeId: fields.reporttype,
        InvestmentCycleId: fields.investmentcycle,
        CompanyId: fields.company,
        CreatedBy: userId,
        FormattedStartDate: dayjs(fields.startDate).format("YYYY-MM-DD HH:mm:ss"),
        FormattedEndDate: dayjs(fields.endDate).format("YYYY-MM-DD HH:mm:ss"),
      };

      const response = await API.post(downloadReport, requestParams);

      if (response?.data.status === 0) {
        const id = response?.data?.id;

        //message.success("Download report requested. ");
        message.success("Report generation request completed successfully, Kindly check in below dashboard.")
        form.resetFields();

        getReportData();
      } else if (response?.data.status === 1) {
        //message.error("Failed to save request.");
        message.error("Failed to generate report.")
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
    } finally {
      hideLoader();
    }
  };

  //handleFileDownload
  const handleFileDownload = async (button: any, recordId: any, item: any) => {
    try {
      showLoader();
      var base64data = "";
      var contenttype = "";

      if (item.filePath) {
        let response = await API.post(getFileData, {
          FilePath: item.filePath,
        });

        if (response.data && response.data.data) {
          base64data = response.data.data;
        }
      } else {
        base64data = item.fileBase64;
      }

      downloadFile(
        base64data,
        item.fileName,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getInvestmentCycle`);
    } finally {
      hideLoader();
    }
  };

  function downloadFile(base64String, fileName, contentType) {
    // Convert Base64 to a binary buffer
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    // Create a temporary link and trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 ">
            <div className="pageName">
              <Title level={4}>{"Reports"}</Title>
            </div>
          </div>
        </div>

        <Form form={form} layout="vertical" validateTrigger="onBlur">
          <Row gutter={[16, 8]} key={"newform"}>
            <Col xs={24} sm={6} md={6}>
              <Form.Item
                name={"type"}
                label={"Type"}
                rules={[{ required: true, message: "Type is required" }]}
              >
                <Select
                  placeholder={"Select Type"}
                  options={formOptions?.categoryType}
                  onChange={(value: any) => getReportTypeDropdown(value)}
                />
              </Form.Item>
            </Col>

            {currCategoryTypeId != 2 && (
              <Col xs={24} sm={6} md={6}>
                <Form.Item
                  name={"investmentcycle"}
                  label={"Investment Cycle"}
                  rules={[
                    { required: true, message: "Investment Cycle is required" },
                  ]}
                >
                  <Select
                    placeholder={"Select Investment Cycle"}
                    options={formOptions?.investmentCycle}
                  />
                </Form.Item>
              </Col>
            )}

            <Col xs={24} sm={6} md={6}>
              <Form.Item
                name={"reporttype"}
                label={"Report Type"}
                rules={[{ required: true, message: "Report Type is required" }]}
              >
                <Select
                  placeholder={"Select Report Type"}
                  options={formOptions?.reportType}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={6} md={6}>
              <Form.Item
                name={"company"}
                label={"Company"}
                rules={[{ required: true, message: "Company is required" }]}
              >
                <Select
                  placeholder={"Select Company"}
                  options={formOptions?.company}
                />
              </Form.Item>
            </Col>

            {( (currCategoryTypeId == 2) || (currCategoryTypeId == 1 && reportsType == 4)) && (
              <>
                <Col xs={24} sm={6} md={6}>
                  <Form.Item
                    name={"startDate"}
                    label={"From Date"}
                    rules={[
                      { required: true, message: "From Date is required" },
                    ]}
                  >
                    <DatePicker className="w-100" format="DD-MMM-YYYY" placeholder="Select Start Date" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6} md={6}>
                  <Form.Item
                    name={"endDate"}
                    label={"To Date"}
                    rules={[{ required: true, message: "To Date is required" }]}
                  >
                    <DatePicker className="w-100" format="DD-MMM-YYYY" placeholder="Select End Date"/>
                  </Form.Item>
                </Col>
              </>
            )}

            <Col xs={24} sm={6} md={6} className="">
              <Button
                className="btn-export mt-4"
                type="default"
                onClick={() => {
                  handleDownloadReport();
                }}
              >
                {"Generate Report"}
              </Button>
            </Col>
          </Row>
        </Form>

        <div className="row">
          <div className="col-lg-12">
            <FormTable
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              loading={isTableLoading}
              filters={filters}
              rowClassName="editable-row"
              dataSource={data}
              isAddRowTable
              columns={mergedColumns}
              scroll={{ x: "max-content", y: "calc(100vh - 200px)" }}
              // condition for check box only visible to employee master screen
              // {...(stateDashboardId == 6 && {
              //     rowSelection : { type : "checkbox" , ...rowSelection}
              // })}
              //
              rowSelection={undefined}
              tableCheckbox={checkBoxFlag}
              showSearchInput={enableSearch}
              handleSearch={handleSearch}
              dashboardId={0}
              pageButtons={pageButtons}
              //handlePageActionClick={handlePageActionClick}
              loadingState={loadingState}
              setLoadingState={setLoadingState}
              handleButtonClick={handleButtonClick}
              pagination={{
                total: totalcount,
                position: ["bottomRight"],
                pageSize: pageSize,
                showSizeChanger: true,
                pageSizeOptions: [5, 10, 20, 50, 100],
                onShowSizeChange: (current, size) => {
                  setPageSize(size);
                  getReportData(null, dataConfig?.reportQuery, size, current);
                },
                onChange: (current, size) => {
                  setPageSize(size);
                  getReportData(
                    filtersvalue,
                    dataConfig?.reportQuery,
                    size,
                    current
                  );
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportRequestDashboard;

// <Col xs={24} sm={6} md={6}>
//                           <FormSelect
//                             name={"type"}
//                             label={"Type"}
//                             rules={[
//                               { required: "true", message: `Type is required` },
//                             ]}
//                             placeholder={"Type"}
//                             widthSize={undefined}
//                             options={formOptions?.categoryType}
//                             mode={undefined}
//                             onChange={(value: any) =>
//                               getReportTypeDropdown(value)
//                             }
//                           />
//                         </Col>

//                         <Col xs={24} sm={6} md={6}>
//                           <FormSelect
//                             name={"investmentcycle"}
//                             label={"Investment Cycle"}
//                             rules={[
//                               { required: "true", message: `Investment Cycle is required` },
//                             ]}
//                             placeholder={"Investment Cycle"}
//                             widthSize={undefined}
//                             options={formOptions?.investmentCycle}
//                             mode={undefined}
//                           />
//                         </Col>

//                         <Col xs={24} sm={6} md={6}>
//                           <FormSelect
//                             name={"reporttype"}
//                             label={"Report Type"}
//                             rules={[
//                               { required: "true", message: `Report Type is required` },
//                             ]}
//                             placeholder={"Report Type"}
//                             widthSize={undefined}
//                             options={formOptions?.reportType}
//                             mode={undefined}
//                           />
//                         </Col>
